import React, { useEffect, useState } from 'react';
import { CheckCircle, MapPin } from 'lucide-react';
const NAMES = ['María', 'Carmen', 'Laura', 'Ana', 'Patricia', 'Rosa', 'Sofía', 'Elena', 'Isabel', 'Claudia'];
const LOCATIONS = [{
  city: 'Buenos Aires',
  country: 'Argentina'
}, {
  city: 'Ciudad de México',
  country: 'México'
}, {
  city: 'Bogotá',
  country: 'Colombia'
}, {
  city: 'Lima',
  country: 'Perú'
}, {
  city: 'Santiago',
  country: 'Chile'
}, {
  city: 'Caracas',
  country: 'Venezuela'
}, {
  city: 'Quito',
  country: 'Ecuador'
}, {
  city: 'Montevideo',
  country: 'Uruguay'
}, {
  city: 'San José',
  country: 'Costa Rica'
}, {
  city: 'Guatemala City',
  country: 'Guatemala'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    location: {
      city: '',
      country: ''
    }
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 5000);
    // Loop
    const interval = setInterval(() => {
      triggerNotification();
    }, Math.random() * (15000 - 8000) + 8000); // Random between 8-15s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomLocation = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
    setNotification({
      name: randomName,
      location: randomLocation
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-40 max-w-sm w-full animate-slide-in-right" data-id="element-242">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-[#0D9488] p-4 flex items-start gap-3" data-id="element-243">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-244">
          <CheckCircle className="w-5 h-5 text-green-600" data-id="element-245" />
        </div>
        <div data-id="element-246">
          <p className="text-sm text-gray-800 font-medium" data-id="element-247">
            <span className="font-bold" data-id="element-248">{notification.name}</span> acaba de
            comprar el MegaPack
          </p>
          <div className="flex items-center gap-1 text-xs text-gray-500 mt-1" data-id="element-249">
            <MapPin className="w-3 h-3" data-id="element-250" />
            {notification.location.city}, {notification.location.country}
          </div>
          <p className="text-xs text-[#0D9488] font-semibold mt-1" data-id="element-251">
            Hace unos segundos
          </p>
        </div>
      </div>
    </div>;
}